module.exports = __webpack_public_path__ + "media/images/thumb/favicon-69f2375509970c5da8d36602cea76f72.ico";